<div class="container">
  <div class="row no-gutters">
      <div class="col-12">
        <div class="d-flex popup-head align-items-center">
          <div class="popup-title mr-auto" translate>lblEditDiagnoseTemplate</div>
          <div class="float-right">
            <a class="close mr-3" (click)="OnClose()" translate>
              <span class="" aria-hidden="true">&times;</span>
              </a>
          </div>
          
        </div>
       
        

      <form [formGroup]="editDiagnoseTemplateForm" (ngSubmit)="editDiagnoseTemplates()">
        
        <div class="scrollbar">
          <div class="card-content">
            <div class="card-body p-0">
              <div class="row ">
                <div class="col-3 af-form-group">
                  <label for="service" translate>lblType <strong class="mlt6 required"> * </strong> </label>
                  <div class='lbl-info'>
                    <div class="form-group">
                      <select class="form-control" formControlName="templateId"
                        [ngClass]="{'is-invalid': cpf.templateId.invalid && cpf.templateId.touched}">
                        <option [ngValue]="null" disabled translate>lblSelectType
                        </option>
                        <option *ngFor="let template of templateType" [ngValue]="template.id">
                          {{template.name}}
                        </option>
                      </select>
                      <div *ngIf="cpf.templateId.invalid && (cpf.templateId.dirty || cpf.templateId.touched)"
                        class="help-block text-danger">
                        <div *ngIf="cpf.templateId.errors.required"><span translate>lblSelectType</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12"
                *ngIf="t.controls && DiagnoseTemplate.templateLanguageDetails && DiagnoseTemplate.templateLanguageDetails.length > 0">
                <div *ngFor="let ticket of t.controls; let i = index">
                   <div [formGroup]="ticket" class="row">
                      <div class="col-6 af-form-group">
                         <label for="name"><span translate>lblName</span><span> in
                         {{languageList[i].value}}</span>
                         <strong class="mlt6 required"> * </strong> </label>
                         <div class="lbl-info">
                            <input formControlName="name" class="form-control mb-2" maxlength="100"
                            [(ngModel)]="DiagnoseTemplate.templateLanguageDetails[i].name"
                            [ngClass]="{'is-invalid': cpf.service.invalid && cpf.service.touched}">
                            <div *ngIf="cpf.service.touched && (cpf.service.errors?.required)"
                               class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                               aria-hidden="true"></em>
                               lblNameRequired
                            </div>
                         </div>
                      </div>
                      <div class="lbl-info" style="display: none;">
                        <input formControlName="languageId" class="form-control mb-2" [ngModel]="languageList[i].id"
                          maxlength="30">
                      </div>
                      <div class="col-6 af-form-group">
                         <label for="description"><span translate>lblTemplate</span><span> in
                         {{languageList[i].value}}</span>
                         <strong class="mlt6 required"> * </strong> </label>
                         <div class='lbl-info'>
                            <input formControlName="description" class="form-control mb-2" maxlength="100"
                            [(ngModel)]="DiagnoseTemplate.templateLanguageDetails[i].description"
                            [ngClass]="{'is-invalid': cpf.service.invalid && cpf.service.touched}">
                            <div *ngIf="cpf.service.touched && (cpf.service.errors?.required)"
                               class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                               aria-hidden="true"></em>
                               lblTemplateRequired
                            </div>
                         </div>
                      </div>
                   </div>
                </div>
             </div>
                <div class="col-12 af-form-group">
                  <div class="lbl-info ml-2">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input" id="isActive" formControlName="isActive">
                      <label class="custom-control-label" for="isActive" translate>lblActive</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-3 bg-light pp-footer-top-brdr">
          <div class="row">
            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
              <button type="submit" class="btn btn-primary btn-lg mr-sm-3" aria-label="Center Align" [disabled]="!editDiagnoseTemplateForm.valid"
                translate>
                <em class="far fa-save font16 align-top mr-2"></em>
                lblSaveChanges</button>
              <a class="btn btn-secondary btn-lg" (click)="OnClose()" translate><em class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</a>
            </div>
          </div>
        </div>
        
      </form>
    </div>
  </div>
</div>